<template>
    <!-- <div>
        <samp>{{panel.caption}}</samp>
        <el-button @click="onClose"></el-button>
    </div> -->
    <div style="display:flex;">
        <!-- 标题 -->
        <el-page-header icon="el-icon-arrow-left" title="返回" :content="caption" @back="onBack"></el-page-header>

        <!-- <div v-if="showToolbar" style="margin: 0 auto; margin-top: 14px">
            <el-button-group>
                <el-button type="primary" size="small" icon="el-icon-plus" @click="onAdd">新增</el-button>
                <el-button type="primary" size="small" icon="el-icon-edit" @click="onEdit">编辑</el-button>
                <el-button type="danger" size="small" icon="el-icon-delete" @click="onDel">删除</el-button>
            </el-button-group>

            <el-button type="success" size="small" style="margin-left:15px" icon="el-icon-finished" @click="onSave">保存</el-button>
        </div> -->

        <!-- 右上角功能区 -->
        <!-- <el-menu style="margin-left:auto;" mode="horizontal"
            background-color="#545c64" text-color="#fff" active-text-color="#fff" @select="subMenuSelect">
            <el-menu-item id="query" class="tw-tablet-menu-item" index="query">
                <i class="el-icon-search"></i>
                <template #title><span>查询</span></template>
            </el-menu-item>
            <el-menu-item id="options" class="tw-tablet-menu-item" index="options">
                <i class="el-icon-setting"></i>
                <template #title><span>选项</span></template>
            </el-menu-item>
            <el-sub-menu class="tw-tablet-menu-item">
                <template #title><i class="el-icon-menu"></i><span>更多</span></template>
                <el-menu-item id="mobile-query" class="tw-tablet-menu-item" index="query">
                    <template #title><span>查询</span></template>
                </el-menu-item>
                <el-menu-item id="mobile-options" class="tw-tablet-menu-item" index="options">
                    <template #title><span>选项</span></template>
                </el-menu-item>
                <tw-tablet-submenu :menus="mainMenus"></tw-tablet-submenu>
            </el-sub-menu>
        </el-menu> -->
    </div>
    
</template>

<script>
import { computed, inject } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import eventBus from '../../utils/event-bus'
// import userService from '../../services/user.service'
// import twTabletSubmenu from './submenus'

export default {
    name: 'tw-tablet-panel-toolbar',
    props: {
        showToolbar: {
            type: Boolean,
            default: false
        }
    },
    // components: {
    //     twTabletSubmenu
    // },
    setup() {
        const route = useRoute()
        const router = useRouter()
        // const panel = userService.routes.find(el => el.name === route.name)
        const caption = computed(() => {
            return route?.meta?.title
        })

        const mainMenus = inject('sys_main_menus');

        const onBack = function() {
            router.back()
        }

        // 子菜单选择时渲染组件
        const subMenuSelect = function(key, keyPath) {
            switch (key) {
                case 'query':
                case 'options':
                    ElMessage.info({
                        showClose: true,
                        message: '功能建设中！'
                    })
                    return;
                default:
                    break;
            }

            // keyPath 是一个菜单主键的数组，第一个元素为第一层的主键，第二个元素为第二层的主键
            const findMenu = function(menuItems, keyPath) {
                const menu = menuItems.find(el => el.id === keyPath[0])
                if (menu) {
                    if (keyPath.length > 1) {
                        return findMenu(menu.children, keyPath.slice(1))
                    } else {
                        return menu
                    }
                }
            }

            const menu = findMenu(mainMenus, keyPath)
            if (menu?.file_name) {
                router.push({ name: menu.file_name })
            } else {
                ElMessage.info({
                    showClose: true,
                    message: '此项未配置页面！'
                })
            }
        }

        const onAdd = function() {
            const params = {}
            eventBus.emit('SYSTEM_STANDARD_EVENT', { event_no: 'STANDARD_NEW', params: params })
        }

        const onEdit = function() {
            const params = {}
            eventBus.emit('SYSTEM_STANDARD_EVENT', { event_no: 'STANDARD_EDIT', params: params })
        }

        const onDel = function() {
            const params = {}
            eventBus.emit('SYSTEM_STANDARD_EVENT', { event_no: 'STANDARD_DELETE', params: params })
        }

        const onSave = function() {
            const params = {}
            eventBus.emit('SYSTEM_STANDARD_EVENT', { event_no: 'STANDARD_SAVE', params: params })
        }

        return {
            onAdd, onEdit, onDel, onSave,
            // panel,
            caption,
            onBack,
            mainMenus,
            subMenuSelect
        }
    }
}
</script>

<style>
.el-page-header__icon {
    margin-top: 0px;
    color: rgb(255, 255, 255);
}
.el-page-header__title {
    margin-top: 20px;
    color: rgb(255, 255, 255);
}
.el-page-header__content {
    margin-top: 20px;
    color: rgb(255, 255, 255);
    /* color: rgb(255, 208, 75); */
}
#mobile-query {
    display: none;
}
#mobile-options {
    display: none;
}
@media screen and (max-width: 585px) {
    #query {
        display: none;
    }
    #options {
        display: none;
    }
    #mobile-query {
        display: inherit;
    }
    #mobile-options {
        display: inherit;
    }
}
</style>